/**
 * Centralized definition of local & session storage keys.
 */

export const AUTHORIZATION = "authorization";
